//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    'panel',
    'expandIcon',
  ],
  data: function() {
    return {
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
      expanded: false,
      expandText: this.$gettext('show more'),
    }
  },
  methods: {
    expand() {
      this.$emit('expand-panel')
      this.expanded = true;
    },
    reset() {
      this.$emit('reset-panel')
      this.expanded = false;
    },
  },
};
